import { Navigate, useLocation } from "react-router-dom";

/**
 * A redirect that keeps the query string and #hash (a plain <Navigate to="/x" /> drops both), so an old
 * link like /admin/crm?region=tx still lands on its region.
 */
export function RedirectKeepingLocation({ to }: { to: string }) {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
}
